import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { McpCliTokenRow } from "../mcpCliTokensViewConfig";
import { tokenStatus } from "../mcpCliTokenHelpers";

export const TokenStatusCell = memo(
    ({ row }: CellContext<ViewTableFeatures, McpCliTokenRow, string>) => (
        <ViewTableCell>{tokenStatus(row.original)}</ViewTableCell>
    ),
);
